// Game catalog of the ruby.club client (Rikvip build): client id, name and lobby group. The CMS
// lists these on the game pages; hide/show and maintenance write client ids (backend/lib/an_game.js).
// Whether a game works is not written here: the API computes it from live data (game-health.ts).
export const GAME_GROUP_LABEL = {
    live: 'Bàn trực tiếp',
    slot: 'Slot',
    mini: 'Mini game',
    card: 'Game bài',
    lottery: 'Lô đề, xổ số',
    studio: 'Live studio',
    partner: 'Đối tác ngoài',
};
export const GAME_HEALTH_LABEL = {
    down: 'Máy chủ không trả lời',
    stopped: 'Đang tạm dừng',
    stuck: 'Có vé treo',
    none: 'Không có máy chủ',
    idle: 'Không có cược 24 giờ',
    ok: 'Có cược 24 giờ',
};
const g = (id, name, group) => ({ id, name, group });
export const GAME_CATALOG = [
    g('ktrng_3980', 'Sicbo', 'live'),
    g('ktrng_3974', 'Baccarat', 'live'),
    g('ktrng_3981', 'Xèng', 'live'),
    g('kts_5996', 'Rồng Hổ mini', 'live'),
    g('ktrng_3973', 'Xì Dách', 'live'),
    g('ktrng_3988', 'Stud Poker', 'live'),
    g('kts_9915', 'Siêu Sao Bóng Đá', 'slot'),
    g('kts_9933', 'Thần Lộc', 'slot'),
    g('kts_9969', 'Dancing Queen', 'slot'),
    g('kts_9971', 'Vampire', 'slot'),
    g('kts_9973', 'Bát Tiên', 'slot'),
    g('kts_9944', 'Lucky Luke', 'slot'),
    g('kts_9952', 'Go To The Moon', 'slot'),
    g('kts_9934', 'Pha Cờ Đen Rồng', 'slot'),
    g('kts_9907', 'Mèo Chiêu Tài', 'slot'),
    g('kts_9855', 'Thợ Săn Nai Vàng', 'slot'),
    g('kts_9851', 'Ngọn Lửa Phượng Hoàng', 'slot'),
    g('kts_9846', 'Bastet', 'slot'),
    g('kts_9812', 'Momotaro', 'slot'),
    g('kts_9986', 'kts_9986', 'slot'),
    g('vgs_204', 'Thần Tài', 'slot'),
    g('vgs_218', 'Night Club Lady', 'slot'),
    g('vgmn_202', 'Kim Cương', 'slot'),
    g('vgmn_224', 'Candy Fruit Samurai', 'slot'),
    g('vgs_219', 'Vòng quay may mắn', 'slot'),
    g('vgs_220', 'Nhanh như chớp', 'slot'),
    g('vgmn_100', 'Tài Xỉu', 'mini'),
    g('vgmn_131', 'ZicZac', 'mini'),
    g('vgmn_201', 'Mini Poker', 'mini'),
    g('vgmn_225', 'Mega Poker', 'mini'),
    g('vgmn_229', 'HiLo', 'mini'),
    g('vgmn_221', 'Aviator', 'mini'),
    g('vgmn_14', 'Bầu Cua mini', 'mini'),
    g('vgmn_103', 'Xóc Đĩa mini', 'mini'),
    g('kts_5995', 'Mini 777', 'mini'),
    g('vgmn_101', 'Tài Xỉu MD5', 'mini'),
    g('txmd5', 'Tài Xỉu MD5 (ô sảnh)', 'mini'),
    g('vgmn_102', 'Tài Xỉu Jackpot', 'mini'),
    g('vgmn_230', 'Dò Mìn', 'mini'),
    g('vgmn_132', 'Du Dính Bắt Đáy', 'mini'),
    g('vgmn_206', 'Cao Thấp', 'mini'),
    g('kta_2995', 'Tâng Bóng', 'mini'),
    g('vgcg_14', 'Bầu Cua', 'card'),
    g('vgcg_9', 'Xóc Đĩa', 'card'),
    g('vgcg_1', 'Tiến Lên Đếm Lá', 'card'),
    g('vgcg_1_2Nguoi', 'Tiến Lên 2 người', 'card'),
    g('vgcg_1_4Nguoi', 'Tiến Lên 4 người', 'card'),
    g('vgcg_2', 'Sâm Lốc', 'card'),
    g('vgcg_4', 'Mậu Binh', 'card'),
    g('vgcg_5', 'Liêng', 'card'),
    g('vgcg_6', 'Poker Texas', 'card'),
    g('vgcg_7', 'Xì Tố', 'card'),
    g('vgcg_8', 'Phỏm', 'card'),
    g('vgcg_11', 'Tiến Lên miền Nam', 'card'),
    g('vgcg_12', 'Poker Omaha', 'card'),
    g('vgcg_16', 'Black Jack', 'card'),
    g('vgcg_17', 'Poker giải đấu', 'card'),
    g('vgld_1005', 'Lô Đề', 'lottery'),
    g('mn_1005', 'Lô Đề Siêu Tốc', 'lottery'),
    g('vgkn_1003', 'Keno Siêu Tốc', 'lottery'),
    g('vgmn_500', 'Lô Đề Siêu Tốc MD5', 'lottery'),
    g('vgmn_108', 'Bầu Cua Live', 'studio'),
    g('vgmn_109', 'Xóc Đĩa Live', 'studio'),
    g('vgmn_110', 'Tài Xỉu Live', 'studio'),
    g('vgmn_111', 'Fantan Live', 'studio'),
    g('vgmn_112', 'Tài Xỉu Live mới', 'studio'),
    g('vgmn_113', 'Xóc Đĩa Live mới', 'studio'),
    g('ktf_1990', 'Bắn Cá', 'partner'),
    g('sbt_1004', 'SABA Sports', 'partner'),
    g('bop_1', 'Ô Thể Thao', 'partner'),
    g('sb_volta', 'Volta', 'partner'),
    g('lcvv_1001', 'Live Casino (tất cả sảnh)', 'partner'),
    g('evolution_casino', 'Live Evolution', 'partner'),
    g('sexybaccarat_casino', 'Live AE Sexy', 'partner'),
    g('dg_casino', 'Live Dream Gaming', 'partner'),
    g('pragmatic_casino', 'Live Pragmatic Play', 'partner'),
    g('wm_casino', 'Live WM Casino', 'partner'),
    g('sa_casino', 'Live SA Gaming', 'partner'),
];
export const GAME_BY_ID = new Map(GAME_CATALOG.map((x) => [x.id, x]));
// One game listed under two ids (engine id and lobby/mini id; backend/lib/co_nguoi_choi.js CUNG_GAME): a giftcode game
// scope ticks or unticks both together.
export const SAME_GAME = [['vgcg_14', 'vgmn_14'], ['vgmn_101', 'txmd5']];
export const sameGameOf = (id) => SAME_GAME.find((g) => g.includes(id)) ?? [id];
export const LIMIT_GAMES = [
    { id: 'ktrng_3980', round: true }, { id: 'ktrng_3974', round: true }, { id: 'kts_5996', round: true }, { id: 'ktrng_3981', round: true },
    { id: 'ktrng_3988', round: true, note: 'CƯỢC + 5+1 + JACKPOT; TỐ không tính' },
    { id: 'vgmn_100', round: true }, { id: 'vgmn_101', round: true }, { id: 'vgcg_14', round: true, note: 'dùng chung cho Bầu Cua mini' }, { id: 'vgmn_103', round: true },
    { id: 'vgmn_131', note: 'một lần thả bóng' }, { id: 'vgmn_221' }, { id: 'vgmn_229' }, { id: 'vgmn_230', note: 'một ván' }, { id: 'vgmn_201', note: 'tổng các tay' }, { id: 'vgmn_225', note: 'tổng các tay' },
    { id: 'kts_9915' }, { id: 'kts_9933' }, { id: 'kts_9969' }, { id: 'kts_9971' }, { id: 'kts_9973' }, { id: 'kts_9944' }, { id: 'kts_9952' },
    { id: 'vgs_204', note: 'tổng các dòng' }, { id: 'vgs_218', note: 'tổng các dòng' }, { id: 'vgmn_202', note: 'tổng các dòng' }, { id: 'vgmn_224' },
    { id: 'vgld_1005', note: 'tổng một phiếu' }, { id: 'mn_1005', note: 'tổng một phiếu' }, { id: 'vgkn_1003' },
    { id: 'vgcg_6', note: 'tiền mua chip vào bàn' }, { id: 'vgcg_12', note: 'tiền mua chip vào bàn' },
    { id: 'ktf_1990', note: 'một viên đạn' },
    { id: 'lcvv_1001', stopOnly: true, note: 'nhà cung cấp tự giới hạn cược; tạm dừng = đóng sảnh' },
];
const CAP = { ktrng_3980: 'pool', ktrng_3974: 'pool', kts_5996: 'pool', vgcg_14: 'fixed', vgmn_103: 'fixed' };
// Texas and Omaha Poker are peer-to-peer and Live Casino is the provider's, so none is counted.
const NO_SAFETY = new Set(['vgcg_6', 'vgcg_12', 'lcvv_1001']);
export const SAFETY_GAMES = LIMIT_GAMES.map((l) => l.id).filter((id) => !NO_SAFETY.has(id))
    .map((id) => (CAP[id] ? { id, cap: CAP[id] } : { id }));
const r = (id, rtp, how, ledger) => ({ id, rtp, how, ledger });
const SLOT_MIX = 'Tỷ lệ lượt quay không trúng gì trong các lượt (ẩn với người chơi); bảng trả giữ nguyên, tiền hũ không đổi';
// Lo de (owner 2026-09-28): pays exactly the Tele88 table; he A never offers a target for it.
const LODE_TELE88 = 'Không chỉnh được: lô đề trả đúng bảng Tele88, chỉnh tỷ lệ ở trang Cấu hình lô đề';
// Tai Xiu (owner 2026-10-14, task tx-phi-tach-rtp): the win fee is its own value (Thông số tiền) and never follows the
// target; the target only changes who wins when the house covers the gap (backend/heB/games/lib/tx_ket_toan.js chonXucXac).
const TX_STEER = 'Kết quả ván khi nhà cái đỡ phần lệch: bên đông tiền thắng ít hơn để phần nhà cái đỡ trả về đúng mức đặt; phí thắng giữ nguyên (Thông số tiền), không đổi tiền trả; áp dụng từ phiên sau';
const MD5_FIXED = 'Không chỉnh được: MD5 chốt xúc xắc và công khai mã SHA256 từ đầu phiên, trước mọi lệnh cược; chỉ thu phí thắng (Thông số tiền)';
// Owner 2026-10-15 (task phi-tach-rtp-moi-game): the target never changes a game's payout table or fee; in these games it
// only changes how often each result comes (backend/lib/rtp_ket_qua.js): every bet returns target / default RTP of its
// default expectation.
const KQ_STEER = (detail) => `Kết quả ván: ${detail} ra thường hơn để cửa chính trả về đúng mức đặt; bảng trả giữ nguyên, không đổi tiền trả; áp dụng từ ván sau`;
export const RTP_GAMES = [
    r('vgmn_221', '95%', 'Đường nổ máy bay (ẩn với người chơi)', 'Aviator'),
    r('vgmn_131', '98%', 'Xác suất bóng rơi vào từng ô; hệ số trên bảng giữ nguyên', 'ZicZac'),
    r('vgmn_229', '98%', KQ_STEER('số làm người chơi thua (hoặc thắng khi mức cao hơn 98%)'), 'HiLo'),
    r('kts_9915', '95,0% (chưa tính hũ)', SLOT_MIX, 'SieuSaoHoiNgo'),
    r('kts_9933', '95,0% (chưa tính hũ)', SLOT_MIX, 'XinXam'),
    r('kts_9969', '95,0% (chưa tính hũ)', SLOT_MIX, 'DancingQueen'),
    r('kts_9971', '95,0% mỗi mức nâng cấp (chưa tính hũ)', SLOT_MIX, 'BaTuocQuyenNang'),
    r('kts_9973', '95,0% (chưa tính hũ)', SLOT_MIX, 'BatTien'),
    r('vgs_204', '95,1% (chưa tính hũ)', SLOT_MIX, 'ThanTai'),
    r('vgs_218', '95,0% (chưa tính hũ)', SLOT_MIX, 'LadyNight'),
    r('vgmn_202', '95,0% (chưa tính hũ)', SLOT_MIX, 'KimCuong'),
    r('vgmn_201', '90,6% (chưa tính hũ)', 'Xác suất ra từng loại bài (ẩn với người chơi); bảng trả giữ nguyên, hũ không đổi', 'MiniPoker'),
    r('ktrng_3980', 'Tài/Xỉu/Chẵn/Lẻ 97,2%, cửa khác 52,8% – 92,1%', KQ_STEER('bộ xúc xắc trả ít cho người chơi thật'), 'Sicbo'),
    r('ktrng_3974', 'Player 98,8%, Banker 98,9%, cửa khác 85,6% – 97,7%', KQ_STEER('ván bài trả ít cho người chơi thật'), 'Baccarat'),
    r('ktrng_3981', 'khoảng 95%', 'Chưa chỉnh được: game đang ẩn (giao thức chưa viết lại)'),
    r('vgmn_225', '96,2% khi giữ bài tối ưu (94,7% theo gợi ý)', KQ_STEER('lá rút vòng 2 trả ít'), 'MegaPoker'),
    r('vgkn_1003', 'cửa 97%, xiên 95%', KQ_STEER('20 số trả ít cho vé người chơi thật'), 'Keno'),
    r('vgld_1005', 'bảng Tele88 theo loại (Lô 2 số 96%, Đề 80%)', LODE_TELE88, 'LoDe'),
    r('mn_1005', 'bảng Tele88 theo loại (Lô 2 số 96%, Đề 80%)', LODE_TELE88, 'LoDeST'),
    r('vgmn_100', '99% (phí 2%)', TX_STEER, 'TaiXiu'),
    r('vgmn_101', '99% (phí 2%)', MD5_FIXED, 'TaiXiuMd5'),
    r('vgcg_14', '91,1% (phí 2%)', KQ_STEER('xúc xắc trả nhiều hơn khi mức trên 91,1% (ít hơn khi dưới)') + '; phí thắng ở Thông số tiền', 'BauCuaTo'),
    r('vgmn_103', 'Chẵn/Lẻ 99%, cửa khác 98,1% – 98,5% (phí 2%)', KQ_STEER('đồng xu trả ít cho người chơi thật') + '; phí thắng ở Thông số tiền', 'XocDia'),
    r('kts_5996', 'Rồng/Hổ 97,1%, Hòa 94,1%', KQ_STEER('lá bài trả ít cho người chơi thật'), 'RongHo'),
    r('ktrng_3988', '94,3% tiền CƯỢC (CƯỢC + TỐ)', KQ_STEER('bài chia trả ít cho người chơi thật'), 'StudPoker'),
    r('vgmn_224', '92,5% (mô phỏng 40 triệu ván)', SLOT_MIX, 'CANDY'),
];
//# sourceMappingURL=games.js.map